// extracted by mini-css-extract-plugin
module.exports = {"todoContainer":"Todo_todoContainer__321qm","list":"Todo_list__3l54U","done":"Todo_done__5s5XH","trash":"Todo_trash__1D55M","completed":"Todo_completed__VSOpW"};